//import { Link } from "react-router-dom";
import { getTableFormattedDate } from "../../../../../helpers/date-time-helper";
import { ColumnDef, createColumnHelper } from "@tanstack/table-core";
import { TJob } from "../../../../../common/types/job";

type JobsTable = Pick<TJob, 'id' | 'companyName' | 'plannedStart' | 'location' | 'approxArea' | 'workSessions'>
type TValue = string | number;

const columnHelper = createColumnHelper<JobsTable>();

export const COLUMNS : ColumnDef<JobsTable, TValue>[]= [
    columnHelper.display({
        id: "id",
        header: "Job Id",
        cell: (props) => props.row.original.id,
        /*cell: (props) => (
            <Link to={`${props.row.original.id}`}>
                {props.row.original.id}
            </Link>
        ),*/
    }),
    columnHelper.accessor<'companyName', string>('companyName', {
        header: 'Company Name',
        id: 'companyName',
        enableColumnFilter: false,
    }),
    columnHelper.accessor<'plannedStart', string>('plannedStart', {
        id: 'plannedStart',
        header: 'Planned Start',
        enableColumnFilter: false,
        cell: (cellProps) => getTableFormattedDate(cellProps.getValue()),
    }),
    columnHelper.accessor<'location', string>('location', {
        id: 'location',
        header: 'Location',
        enableColumnFilter: false,
        enableSorting: true,
    }),
    columnHelper.display({
        id: 'approxArea',
        header: 'Approx Area',
        enableColumnFilter: false,
        enableSorting: false,
    }),
    columnHelper.accessor<'workSessions', string>('workSessions', {
        header: 'Work Sessions',
        id: 'workSessions',
        enableColumnFilter: false,
    }),
];
